import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import avatarSvg from "../assets/Group 6552.svg";
import card1 from "../assets/Industrial gas_small.jpg";
import card2 from "../assets/Cloudcost_small.jpg";
import card3 from "../assets/digiyatra_small.jpg";

const SPECS_CURSOR = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='48' height='28' viewBox='0 0 48 28'%3E%3Crect x='1' y='4' width='18' height='18' rx='9' ry='9' fill='none' stroke='%231a1a1a' stroke-width='2.5'/%3E%3Crect x='29' y='4' width='18' height='18' rx='9' ry='9' fill='none' stroke='%231a1a1a' stroke-width='2.5'/%3E%3Cpath d='M19 13 L29 13' stroke='%231a1a1a' stroke-width='2.5' stroke-linecap='round'/%3E%3Cpath d='M1 13 L0 8' stroke='%231a1a1a' stroke-width='2' stroke-linecap='round'/%3E%3Cpath d='M47 13 L48 8' stroke='%231a1a1a' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E`;

const css = `
  *, *::before, *::after { box-sizing:border-box; scroll-behavior:smooth; margin:0; padding:0; }
  body { background:#fafafa; cursor:url("${SPECS_CURSOR}") 24 14,auto; }
  a,button { cursor:url("${SPECS_CURSOR}") 24 14,pointer; }

  @keyframes fadeUp { from{opacity:0;transform:translateY(20px)} to{opacity:1;transform:translateY(0)} }
  @keyframes bounceDown { 0%,100%{transform:translateY(0)} 50%{transform:translateY(7px)} }
  @keyframes slideLeft {
    from{opacity:0;transform:rotate(-15deg) translateX(20px)}
    to{opacity:1;transform:rotate(-15deg) translateX(0)}
  }
  @keyframes slideRight {
    from{opacity:0;transform:rotate(15deg) translateX(-20px)}
    to{opacity:1;transform:rotate(15deg) translateX(0)}
  }
  @keyframes bubblePop {
    0%{opacity:0;transform:translateX(-50%) translateY(6px) scale(0.9)}
    100%{opacity:1;transform:translateX(-50%) translateY(0) scale(1)}
  }

  .anim-d0{animation:fadeUp .65s .00s ease both}
  .anim-d1{animation:fadeUp .65s .12s ease both}
  .anim-d2{animation:fadeUp .65s .24s ease both}
  .anim-d3{animation:fadeUp .65s .38s ease both}
  .anim-d4{animation:fadeUp .65s .52s ease both}
  .anim-d5{animation:fadeUp .65s .66s ease both}

  .reveal{opacity:0;transform:translateY(28px);transition:opacity .7s ease,transform .7s ease}
  .reveal.visible{opacity:1;transform:translateY(0)}

  /* keyboard */
  .tile-key{
    display:inline-flex;align-items:center;justify-content:center;
    font-family:'DM Sans',sans-serif;font-weight:700;color:#1a1a1a;
    background:#fff;border:2.5px solid #d0d0d0;border-radius:10px;
    box-shadow:0 3px 10px rgba(0,0,0,0.09),0 1px 3px rgba(0,0,0,0.05);
    user-select:none;position:relative;flex-shrink:0;
    transition:transform .15s,box-shadow .15s,border-color .15s,background .15s;
  }
  .tile-key:hover{background:#f8f8f8;border-color:#999;transform:translateY(-3px) scale(1.08);box-shadow:0 8px 20px rgba(0,0,0,0.12)}
  .tile-key.active-key{background:#f5d930!important;border-color:#d4b800!important;transform:translateY(-3px) scale(1.08)!important;box-shadow:0 8px 24px rgba(245,217,48,0.5)!important}

  .hero-highlight{background:#f5d930;border-radius:4px;font-style:italic;color:#1a1a1a;display:inline-block}
  .hero-pin{width:12px;height:12px;background:#f5d930;border-radius:50%;display:inline-block;flex-shrink:0;box-shadow:0 2px 6px rgba(245,217,48,0.55)}

  /* project cards */
  .proj-card{transition:transform .3s,box-shadow .3s;border-radius:16px;overflow:hidden}
  .proj-card:hover{transform:translateY(-4px);box-shadow:0 20px 48px rgba(0,0,0,0.12)}
  .proj-card .proj-img{transition:transform .5s}
  .proj-card:hover .proj-img{transform:scale(1.04)}

  /* scroll cue */
  .scroll-cue{animation:bounceDown 1.8s ease-in-out infinite}
  .contact-link{font-weight:600;color:#1a1a1a;text-decoration:underline;text-decoration-color:rgba(0,0,0,0.22);text-underline-offset:3px}
  .contact-link:hover{text-decoration-color:#1a1a1a}

  /* reveal button */
  .reveal-wrap{position:relative;display:inline-flex;align-items:center;justify-content:center;cursor:pointer}
  .reveal-bubble{
    position:absolute;top:-54px;left:50%;transform:translateX(-50%);
    background:#111;color:#fff;
    font-family:'DM Sans',sans-serif;font-size:12px;font-weight:700;
    white-space:nowrap;padding:9px 16px;border-radius:20px;
    pointer-events:none;opacity:0;transition:opacity .2s ease;
  }
  .reveal-bubble::after{
    content:'';position:absolute;top:100%;left:50%;transform:translateX(-50%);
    border:7px solid transparent;border-top-color:#111;
  }
  .reveal-wrap:hover .reveal-bubble{opacity:1;animation:bubblePop .25s ease both}
  .reveal-avatar{
    width:100px;height:100px;border-radius:50%;background:#f5d930;
    display:flex;align-items:center;justify-content:center;
    position:relative;z-index:2;
    transition:transform .3s ease;
    box-shadow:0 6px 24px rgba(0,0,0,0.18);
    overflow:hidden;
  }
  .reveal-wrap:hover .reveal-avatar{transform:scale(1.05)}
  .reveal-card-left,.reveal-card-right{
    position:absolute;top:50%;width:72px;height:72px;border-radius:12px;
    background:#111;display:flex;align-items:center;justify-content:center;
    opacity:0;pointer-events:none;z-index:1;
    transition:opacity .3s ease,transform .35s ease;
  }
  .reveal-card-left{left:-40px;transform:rotate(-15deg) translateX(20px)}
  .reveal-card-right{right:-40px;transform:rotate(15deg) translateX(-20px)}
  .reveal-wrap:hover .reveal-card-left{opacity:1;transform:rotate(-15deg) translateX(0);animation:slideLeft .35s ease both}
  .reveal-wrap:hover .reveal-card-right{opacity:1;transform:rotate(15deg) translateX(0);animation:slideRight .35s .05s ease both}

  ::-webkit-scrollbar{width:4px}
  ::-webkit-scrollbar-track{background:#fafafa}
  ::-webkit-scrollbar-thumb{background:#e0e0e0;border-radius:4px}
`;

/* ── hooks ── */
function useWidth() {
  const [w, setW] = useState(typeof window !== "undefined" ? window.innerWidth : 1024);
  useEffect(() => {
    const fn = () => setW(window.innerWidth);
    window.addEventListener("resize", fn); return () => window.removeEventListener("resize", fn);
  }, []);
  return w;
}
function useReveal() {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current; if (!el) return;
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) { el.classList.add("visible"); obs.disconnect(); } }, { threshold:0.1 });
    obs.observe(el); return () => obs.disconnect();
  }, []);
  return ref;
}

/* ── keyboard ── */
const KEY_SKILLS = {
  A:"Always asking 'Why?'",     B:"B2B SaaS specialist",      C:"Creating beyond screens",
  D:"Design systems thinker",   E:"Enterprise UX focus",       F:"Figma-first workflow",
  G:"Grid-based precision",     H:"Human-first, always",       I:"Information architecture",
  J:"Journey mapping",          K:"Keeping curiosity alive",   L:"Listening before designing",
  M:"Making complexity simple", N:"Never settling for average",O:"Obsessed with great UX",
  P:"Prototyping ideas fast",   Q:"Questioning assumptions",   R:"Research-driven decisions",
  S:"Systems thinking",         T:"Turning ideas into impact", U:"Understanding users deeply",
  V:"Visual design precision",  W:"Wireframing with purpose",  X:"Cross-platform experience",
  Y:"Your creative collaborator",Z:"Zero friction by design",
};
const ROWS = [["A","B","C","D","E","F","G","H","I","J"],["K","L","M","N","O","P","Q","R","S","T"],["U","V","W","X","Y","Z"]];

function TileKey({ letter, active, onEnter, onLeave, size }) {
  return (
    <div className={`tile-key${active ? " active-key" : ""}`}
      style={{ width:size, height:size, fontSize:size*0.38 }}
      onMouseEnter={() => onEnter(letter)} onMouseLeave={onLeave}>
      {letter}
    </div>
  );
}
function Keyboard({ activeKey, onKeyEnter, onKeyLeave, isMobile }) {
  const size = isMobile ? 28 : 58;
  const gap  = isMobile ? 5  : 12;
  return (
    <div style={{ display:"flex", flexDirection:"column", alignItems:"center", gap }}>
      {ROWS.map((row, ri) => (
        <div key={ri} style={{ display:"flex", gap }}>
          {row.map(l => <TileKey key={l} letter={l} active={activeKey===l} onEnter={onKeyEnter} onLeave={onKeyLeave} size={size} />)}
        </div>
      ))}
    </div>
  );
}

/* ── scroll cue ── */
function ScrollCue({ onClick }) {
  return (
    <div className="scroll-cue" onClick={onClick} style={{ display:"flex", flexDirection:"column", alignItems:"center", gap:8, marginTop:40, opacity:0.4, cursor:"pointer" }}>
      <svg width="44" height="26" viewBox="0 0 52 30" fill="none">
        <rect x="2" y="5" width="19" height="19" rx="9.5" stroke="#1a1a1a" strokeWidth="2.2"/>
        <rect x="31" y="5" width="19" height="19" rx="9.5" stroke="#1a1a1a" strokeWidth="2.2"/>
        <line x1="21" y1="14.5" x2="31" y2="14.5" stroke="#1a1a1a" strokeWidth="2.2" strokeLinecap="round"/>
      </svg>
      <span style={{ fontFamily:"'DM Sans',sans-serif", fontSize:10, letterSpacing:"0.18em", textTransform:"uppercase", color:"#1a1a1a" }}>scroll</span>
    </div>
  );
}

/* ── reveal button ── */
function RevealButton({ navigate }) {
  return (
    <div style={{ display:"flex", flexDirection:"column", alignItems:"center" }}>
      <div className="reveal-wrap" onClick={() => navigate("/about")} style={{ width:220, height:110 }}>
        <div className="reveal-bubble">Click to reveal me!</div>
        <div className="reveal-card-left">
          <span style={{ fontFamily:"'DM Sans',sans-serif", fontSize:9, fontWeight:900, color:"#f5d930", textTransform:"uppercase", letterSpacing:".04em", textAlign:"center", lineHeight:1.3 }}>CREA-{"\n"}TIVE</span>
        </div>
        <div className="reveal-avatar">
          <img src={avatarSvg} alt="Satish" style={{ width:"100%", height:"100%", objectFit:"cover" }} />
        </div>
        <div className="reveal-card-right">
          <span style={{ fontFamily:"'DM Sans',sans-serif", fontSize:9, fontWeight:900, color:"#f5d930", textTransform:"uppercase", letterSpacing:".04em", textAlign:"center", lineHeight:1.3 }}>DESI-{"\n"}GNER</span>
        </div>
      </div>
    </div>
  );
}

/* ── project card ── */
function ProjectCard({ image, tag, title, description, scope, outcome, number, accentBg, isMobile }) {
  const navigate = useNavigate();
  return (
    <div className="proj-card"
      onClick={() => navigate(`/case-study/${tag.toLowerCase()}`)}
      style={{ background:"#fff", border:"1px solid #e8e8e8", borderRadius:20, overflow:"hidden",
        display:"grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
        minHeight: isMobile ? "auto" : 280, boxShadow:"0 2px 16px rgba(0,0,0,0.06)", cursor:"pointer" }}>
      {/* left */}
      <div style={{ padding: isMobile ? "28px 22px 24px" : "36px 36px 32px", display:"flex", flexDirection:"column", justifyContent:"space-between" }}>
        <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom: isMobile ? 16 : 20 }}>
          <span style={{ fontFamily:"'DM Sans',sans-serif", fontSize:11, fontWeight:700, color:"#bbb" }}>{String(number).padStart(2,"0")}</span>
          <div style={{ height:1, width:28, background:"#ddd" }} />
          <span style={{ fontFamily:"'DM Sans',sans-serif", fontSize:10, fontWeight:600, letterSpacing:".18em", textTransform:"uppercase", color:"#bbb" }}>{tag}</span>
        </div>
        <h2 style={{ fontFamily:"'DM Sans',sans-serif", fontSize: isMobile ? 20 : 26, fontWeight:800, color:"#1a1a1a", lineHeight:1.2, letterSpacing:"-0.02em", marginBottom:14 }}>{title}</h2>
        <p style={{ fontFamily:"'DM Sans',sans-serif", fontSize:14, color:"#666", lineHeight:1.75, marginBottom: isMobile ? 20 : 32, flex:1 }}>{description}</p>
        <div style={{ borderTop:"1px solid #f0f0f0", paddingTop:18, display:"grid", gridTemplateColumns:"1fr 1fr", gap:16 }}>
          <div>
            <p style={{ fontFamily:"'DM Sans',sans-serif", fontSize:9, fontWeight:700, letterSpacing:".18em", textTransform:"uppercase", color:"#bbb", marginBottom:6 }}>Scope</p>
            <p style={{ fontFamily:"'DM Sans',sans-serif", fontSize:13, fontWeight:500, color:"#1a1a1a", lineHeight:1.5 }}>{scope}</p>
          </div>
          <div>
            <p style={{ fontFamily:"'DM Sans',sans-serif", fontSize:9, fontWeight:700, letterSpacing:".18em", textTransform:"uppercase", color:"#bbb", marginBottom:6 }}>Outcome</p>
            <p style={{ fontFamily:"'DM Sans',sans-serif", fontSize:13, fontWeight:500, color:"#1a1a1a", lineHeight:1.5 }}>{outcome}</p>
          </div>
        </div>
      </div>
      {/* right image */}
      <div style={{ background: accentBg||"#f5f5f5", overflow:"hidden", minHeight: isMobile ? 220 : 280, display:"flex", alignItems:"center", justifyContent:"center" }}>
        <img src={image} alt={title} className="proj-img" loading="eager" decoding="async" fetchpriority="high" style={{ width:"100%", height:"100%", objectFit:"cover", display:"block" }} />
      </div>
    </div>
  );
}

/* ══════════════════════════════════════════════ MAIN */
export default function Home() {
  const navigate = useNavigate();
  const [scrollProgress, setScrollProgress] = useState(0);
  const [activeKey, setActiveKey]   = useState(null);
  const [displayedText, setDisplayedText] = useState("Designing Scalable B2B SaaS");
  const caseStudiesRef = useRef(null);
  const width    = useWidth();
  const isMobile = width < 640;

  const handleKeyEnter = (l) => { setActiveKey(l); setDisplayedText(KEY_SKILLS[l]); };
  const handleKeyLeave = ()  => { setActiveKey(null); setDisplayedText("Designing Scalable B2B SaaS"); };

  useEffect(() => {
    const fn = () => { const el = document.documentElement; setScrollProgress((el.scrollTop/(el.scrollHeight-el.clientHeight))*100); };
    window.addEventListener("scroll", fn); return () => window.removeEventListener("scroll", fn);
  }, []);

  return (
    <div style={{ background:"#fafafa", minHeight:"100vh", backgroundImage:"linear-gradient(rgba(0,0,0,0.045) 1px,transparent 1px),linear-gradient(90deg,rgba(0,0,0,0.045) 1px,transparent 1px)", backgroundSize:"32px 32px" }}>
      <style>{css}</style>

      {/* progress bar */}
      <div style={{ position:"fixed", top:0, left:0, right:0, height:3, background:"rgba(0,0,0,0.05)", zIndex:100 }}>
        <div style={{ height:"100%", background:"#f5d930", width:`${scrollProgress}%`, transition:"width .3s" }} />
      </div>

      <Navbar />

      {/* ══ HERO ══ */}
      <section style={{ minHeight:"100vh", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding: isMobile ? "60px 16px 48px" : "80px 24px 60px", textAlign:"center" }}>
        {/* bracket + text */}
        <div className="anim-d1" style={{ display:"flex", alignItems:"center", justifyContent:"center", gap:6, marginBottom: isMobile ? 32 : 48, flexWrap:"wrap" }}>
          <span className="hero-pin" />
          <span style={{ fontFamily:"'Courier Prime',monospace", fontSize: isMobile ? "clamp(16px,5vw,24px)" : "clamp(22px,3.5vw,46px)", color:"#1a1a1a", opacity:0.55 }}>[</span>
          <span className="hero-highlight" style={{ fontSize: isMobile ? "clamp(16px,5vw,24px)" : "clamp(22px,3.5vw,46px)", fontFamily:"'Courier Prime',monospace", padding: isMobile ? "3px 10px 5px" : "5px 18px 7px" }}>
            {displayedText}
          </span>
          <span style={{ fontFamily:"'Courier Prime',monospace", fontSize: isMobile ? "clamp(16px,5vw,24px)" : "clamp(22px,3.5vw,46px)", color:"#1a1a1a", opacity:0.55 }}>]</span>
          <span className="hero-pin" />
        </div>

        {/* keyboard */}
        <div className="anim-d2">
          <Keyboard activeKey={activeKey} onKeyEnter={handleKeyEnter} onKeyLeave={handleKeyLeave} isMobile={isMobile} />
        </div>
        <p className="anim-d3" style={{ marginTop:12, fontFamily:"'DM Sans',sans-serif", fontSize:11, color:"#bbb", letterSpacing:".05em", minHeight:18 }}>
          {activeKey ? "move away to reset" : "hover any key to explore skills"}
        </p>

        {/* bio */}
        <div className="anim-d4" style={{ marginTop:36, maxWidth: isMobile ? "100%" : 500 }}>
          <p style={{ fontFamily:"'DM Sans',sans-serif", fontSize: isMobile ? 13.5 : 14.5, color:"#555", lineHeight:1.85, marginBottom:8 }}>
            UI/UX designer with 4+ years of experience building enterprise-grade B2B SaaS products. I specialize in simplifying complex workflows, designing scalable systems, and creating intuitive experiences for data-heavy platforms.
          </p>
          <p style={{ fontFamily:"'DM Sans',sans-serif", fontSize: isMobile ? 13 : 13.5, color:"#999", lineHeight:1.75, marginBottom:18 }}>
            I turn complex systems into simple, user-friendly interfaces.
          </p>
          <p style={{ fontFamily:"'DM Sans',sans-serif", fontSize: isMobile ? 13 : 14, color:"#555" }}>
            Feel free to connect on{" "}
            <a href="https://www.linkedin.com/in/satish-dandabathula-00b35115b/" target="_blank" rel="noopener noreferrer" className="contact-link">LinkedIn</a>
          </p>
        </div>

        {/* reveal button */}
        <div className="anim-d5" style={{ marginTop:36 }}>
          <RevealButton navigate={navigate} />
        </div>

        {/* scroll cue */}
        {!isMobile && (
          <div className="anim-d5">
            <ScrollCue onClick={() => caseStudiesRef.current?.scrollIntoView({ behavior:"smooth" })} />
          </div>
        )}
      </section>

      {/* ══ MAIN ══ */}
      <main style={{ maxWidth:1060, margin:"0 auto", padding: isMobile ? "0 16px 64px" : "0 40px 96px" }}>

        {/* case studies */}
        <section ref={caseStudiesRef} style={{ paddingTop:48, paddingBottom:56 }}>
          <div style={{ display:"flex", flexDirection:"column", gap:16 }}>
           <ProjectCard image={card3} tag="Digiyatra" number={1}
              title="Seamless Airport Travel Experience"
              description="Designing a frictionless, contactless airport journey using facial recognition — from one-time onboarding to walk-through boarding gate."
              scope="Mobile Application · B2C" outcome="From 4–6 ID checks to one face scan"
              accentBg="#0a1a0f" isMobile={isMobile} />
                   <ProjectCard image={card2} tag="Cloudevolve" number={2}
              title="Cloud Cost Optimization Platform"
              description="A FinOps SaaS platform that transforms raw cloud spend data into prioritised, actionable savings opportunities for DevOps and Finance teams."
              scope="Web Application · B2B SaaS" outcome="From raw spend data to actionable savings"
              accentBg="#0a0a2a" isMobile={isMobile} />
            <ProjectCard image={card1} tag="Industrialgas" number={3}
              title="Digitizing Work Permits for IndustrialGas"
              description="Replacing a paper-based safety permit system with a mobile-first app that enforces compliance by design for field workers in industrial environments."
              scope="Mobile Application · Enterprise" outcome="From paper forms to hard-gated digital compliance"
              accentBg="#1a0a02" isMobile={isMobile} />
       
           
          </div>
        </section>

      </main>

    
    </div>
  );
}